<ng-container>
  @for (_ of [].constructor(7); track $index) {
    <div class="weekday f-body-xs f-medium">
      {{ `${I18N}.days.${$index}` | translate }}
    </div>
  }

  <ng-container>
    @let currentMonth = DateTime.fromISO(calendar()[0]).month;
    @let from = dateRange().from;
    @let to = dateRange().to;
    @let isRange = from && to;

    @for (day of getCalendarDays(); track DateTime.fromISO(day)) {
      @let month = DateTime.fromISO(day).month;
      @let isCurrentMonth = month === currentMonth;

      <button
        class="calendar-day"
        [class.previous-month]="month < currentMonth"
        [class.next-month]="month > currentMonth"
        [class.today]="day === today()"
        [class.active]="(day === from || day === to) && isCurrentMonth"
        [class.active-start]="day === from && isCurrentMonth"
        [class.active-end]="day === to && isCurrentMonth"
        [class.active-range]="
          isRange && day > from && day < to && isCurrentMonth
        "
        [class.same-week]="
          isRange &&
          DateTime.fromISO(from).hasSame(DateTime.fromISO(to), 'week')
        "
        [class.is-range]="from && to"
        [disabled]="disableDate()(dateRange(), day)"
        (click)="dateChange.emit(day)"
      >
        {{ DateTime.fromISO(day).day }}
      </button>
    }
  </ng-container>
</ng-container>
